import type { PayrollPlugin } from "./types";

const COLOMBIA_2026_PROFILE = {
  anio: 2026,
  smmlv: 1_750_905,
  auxilioTransporte: 249_095,
  uvt: 47_065,
  topeAuxilioTransporte: 1_750_905 * 2,
  porcentajes: {
    saludEmpleado: 0.04,
    pensionEmpleado: 0.04,
    saludEmpleador: 0.085,
    pensionEmpleador: 0.12,
    parafiscales: { sena: 0.02, icbf: 0.03, caja: 0.04 },
    prestaciones: {
      cesantias: 0.0833,
      interesesCesantias: 0.01,
      prima: 0.0833,
      vacaciones: 0.0417,
    },
    riesgosLaborales: { clase1: 0.00522 },
  },
  recargos: {
    horaExtraDiurna: 1.25,
    horaExtraNocturna: 1.75,
    recargoNocturno: 0.35,
    dominicalFestivo: 1.75,
    extraDominicalDiurna: 2,
    extraDominicalNocturna: 2.5,
  },
} as const;

export const COLOMBIA_PAYROLL_PLUGIN: PayrollPlugin = {
  id: "co-legal-2026",
  countryCode: "CO",
  mode: "legal",
  label: "Colombia 2026",
  legalProfile: COLOMBIA_2026_PROFILE,
};
